function findEntity(value, entities) {
  if (!value) return null
  return entities.find((entity) => Object.values(entity ?? {}).some((field) => String(field) === String(value))) ?? null
}

function getEntityField(entities, type, field) {
  return entities.find((entity) => Object.values(entity ?? {}).some((field) => String(field) === String(type)))?.[field] ?? ''
}

function setEntity(entities, type, entity) {
  const others = entities.filter((entity) => entity?.type !== type)
  if (!entity?.id) return others
  return [...others, { type, id: String(entity.id), name: entity.name ?? '' }]
}

function mapEntities(entities, field) {
  return entities.map((entity) => ({ value: entity._id, label: entity[field] }))
}

class EntityUtility {
  /**
   * Find one row in `entities` when any field value equals `value`
   * (string-coerced). Pass `entities` explicitly (`[]` when empty).
   *
   * @param {string|null|undefined} value
   * @param {object[]} entities
   * @returns {object|null} The matched row, or `null` when `value` is missing or not found.
   */
  find(value, entities) {
    return findEntity(value, entities)
  }

  /**
   * Read a field from the row whose key matches `type` (string-coerced).
   * Pass `entities` explicitly (`[]` when empty).
   *
   * @param {object[]} entities
   * @param {string} type
   * @param {string} field
   * @returns {string} Field value, or `''` when the row or field is missing.
   */
  get(entities, type, field) {
    return getEntityField(entities, type, field)
  }

  /**
   * Replace the row for `type` with `entity`, or drop that row when
   * `entity` has no id. Returns a new array; other rows keep their order.
   * Pass `entities` explicitly (`[]` when empty).
   *
   * @param {object[]} entities
   * @param {string} type
   * @param {{ id?: string, name?: string }|null|undefined} entity
   * @returns {object[]}
   */
  set(entities, type, entity) {
    return setEntity(entities, type, entity)
  }

  /**
   * Map each row to `{ value: _id, label: row[field] }`. Pass `entities`
   * explicitly (`[]` when empty).
   *
   * @param {object[]} entities
   * @param {string} field
   * @returns {Array<{ value: string, label: string }>}
   */
  map(entities, field) {
    return mapEntities(entities, field)
  }
}

export default new EntityUtility()
